import React from "react";
import "./Footer.css";
import footerlogo from "../../Assets/carrerup_allInOne_cover_NoBg.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="wb-footer">
      <div className="wb-footer-glow"></div>

      <div className="wb-footer-content">

        {/* LEFT */}
        <div className="wb-footer-brand">
          <img src={footerlogo} alt="CarrerUp" />

          <p>
            {t("footer.description")}
          </p>

          {/* <div className="wb-footer-socials">
            <a href="https://instagram.com"><FaFacebookF /></a>
            <a href="https://instagram.com"><FaInstagram /></a>
            <a href="https://instagram.com"><FaLinkedinIn /></a>
            <a href="https://instagram.com"><FaTwitter /></a>
          </div> */}
        </div>

        {/* LINKS */}
        {/* <div className="wb-footer-column">
          <h3>
            {t("footer.navigation")}
          </h3>
          <a href="https://instagram.com">
            {t("footer.home")}
          </a>

          <a href="https://instagram.com">
            {t("footer.ecosystem")}
          </a>

          <a href="https://instagram.com">
            {t("footer.features")}
          </a>

          <a href="https://instagram.com">
            {t("footer.contact")}
          </a>
        </div> */}

        {/* LEGAL */}
        <div className="wb-footer-column">
          <h3>
            {t("footer.legal")}
          </h3>
          <Link to="/privacy-policy">
            {t("footer.privacy")}
          </Link>
          <Link to="/child-safety">
            {t("footer.childSafety")}
          </Link>
        </div>

        {/* CONTACT */}
        <div className="wb-footer-column">
          <h3>
            {t("footer.contactTitle")}
          </h3>
          <p>{t('footer.contactTitle')} : contact@carrerup.com</p>
          <p>{t('footer.contactTitle')} : support@carrerup.com</p>
          <p>
            {t("footer.available")}
          </p>
        </div>

      </div>

      <div className="wb-footer-bottom">
        © {currentYear} CarrerUp — {t("footer.rights")}
      </div>
    </footer>
  );
};

export default Footer;
